/**
 * Angleščina je vir resnice za KLJUČE, ne za slog (T1 §11).
 * Slovenski nizi se pišejo po slovenskih pravilih, ne kot preslikava
 * angleške stavčne zgradbe. Pravila: P4.
 *
 * Tudi v angleščini velja stavčna začetnica, ne Title Case (P4 §3).
 */
export const en = {
  'app.name': 'Nesywave',

  'tab.stations': 'Stations',
  'tab.search': 'Search',
  'tab.history': 'History',
  'tab.timer': 'Timer',
  'tab.settings': 'Settings',

  'a11y.mainNav': 'Main navigation',
  // Oznaka pove cilj IN da se odpre drugje: novo okno brez napovedi je za
  // bralnik zaslona nenapovedana menjava konteksta.
  'a11y.brandHome': 'nesylab.com, opens in a new tab',
  'a11y.toggleTheme': 'Switch theme',
  'a11y.skipToContent': 'Skip to content',
  'a11y.stationList': 'Stations',

  // Predvajanje. Gumbi so velelniki, 1–3 besede (P4 §4).
  'player.play': 'Play',
  'player.stop': 'Stop',
  'player.previous': 'Previous station',
  'player.next': 'Next station',
  'player.nothing': 'Nothing playing',
  'player.pickStation': 'Pick a station',
  'player.connecting': 'Connecting…',
  'player.live': 'Live',
  // Brez besede „napaka", brez kod, brez klicajev (P4 §5).
  'player.retrying': 'Connection lost. Retrying, attempt {n}…',
  'player.offline': 'Station is not responding',
  'player.blocked': 'Ready — press play',
  // Ločilo med izvajalcem in naslovom je tipografska odločitev jezika, zato
  // stoji v slovarju in ne v kodi (P4 §7).
  'player.track': '{artist} — {title}',
  // Bere ga samo bralnik zaslona, z zamikom in brez ponavljanja (P2 §3).
  'player.announce': 'Now playing: {track}',

  // Glasnost (P2 §3.5). Gumb pove, kaj bo naredil — zato dve imeni in ne
  // `aria-pressed` (P2 §9, merilo 4.1.2).
  'player.volume': 'Volume',
  'player.mute': 'Mute',
  'player.unmute': 'Unmute',
  // Odpoved je glasna, ne tiha (P2 §6.5). Brez besede „napaka", brez krivde:
  // to je odločitev platforme in uporabnik ne more narediti ničesar (P4 §5).
  // Stoji v razširjenem pogledu, ker je tam edini kraj, kjer se vidi, da je
  // od glasnosti ostal sam gumb za tišino (B-5, 2026-07-22).
  'player.volume.unsupported':
    'iPhone and iPad keep the volume on the hardware buttons. Mute still works here, and so does the sleep timer.',

  // Razširjen pogled in način za avto (P2 §3.11, §7). Gumbi so velelniki.
  'player.expand': 'Expand',
  'player.collapse': 'Close',
  'player.expanded': 'Now playing',
  'player.car': 'Car mode',
  'player.car.exit': 'Leave car mode',

  // Poišči skladbo (P2 §3.12, §4.8). Navaden iskalni naslov, brez API-ja.
  // {service} je znamka (Apple Music, Spotify, YouTube) in se ne prevaja.
  'song.find': 'Find this song',
  'song.findOn': 'Find this song on {service}',

  'route.direct': 'Direct',
  'route.proxy': 'Via our server',

  // Kakovost NI status: bitrate je nevtralen podatek (CLAUDE.md, signal ≠ status).
  'meta.bitrate': '{n}{nbsp}kbps',

  'search.clear': 'Clear search',
  'stations.search.label': 'Search your stations',
  'stations.search.placeholder': 'Search',
  'stations.sort.label': 'Sort',
  'stations.sort.custom': 'My order',
  'stations.sort.az': 'A–Z',
  'stations.sort.za': 'Z–A',
  'stations.sort.recent': 'Recent',
  'stations.favoritesOnly': 'Favourites',

  // Prazno stanje ima naslov, opis in dejanje — nikoli le „ni podatkov" (P4 §6).
  'stations.empty.title': 'No stations yet',
  'stations.empty.body': 'Add one of your own, or find stations online.',
  // Prazno zaradi filtra je nekaj drugega kot prazna knjižnica: pot ven je
  // drugačna in „dodajte postajo" bi tu zavajalo.
  'stations.empty.filtered.title': 'Nothing matches',
  'stations.empty.filtered.body': 'Try another search, or turn off the favourites filter.',

  'stations.add': 'Add station',

  'station.play': 'Play {station}',
  // Ime dejanja sledi stanju: gumb pove, kaj bo naredil (P4 §4).
  'station.favourite': 'Add {station} to favourites',
  'station.unfavourite': 'Remove {station} from favourites',
  'station.more': 'More actions for {station}',
  // Skok na rob (P2 §1.8): premik za deset mest je bil deset klikov.
  'station.moveTop': 'Move to top',
  'station.moveUp': 'Move up',
  'station.moveDown': 'Move down',
  'station.moveBottom': 'Move to bottom',
  'station.edit': 'Edit',
  'station.delete': 'Remove',
  'station.delete.title': 'Remove this station?',
  'station.delete.body': '{station} will be gone from your list. Export first if you want it back.',

  // Način urejanja (P2 §1.7). Gumb je velelnik in preklopi med obema stanjema.
  'stations.reorder.start': 'Reorder',
  'stations.reorder.done': 'Done',
  'stations.reorder.hint': 'Drag by the handle, or use the menu to jump to the top or bottom.',
  'station.dragHandle': 'Drag {station} to reorder',
  // Naznanilo živi regije ob premiku — ločeno od zapisa (D2 §52). Dvojina ni
  // potrebna: „of N" ni števna kategorija, ampak položaj v seznamu.
  'stations.reorder.moved': '{station} moved to position {index} of {total}',

  // Deljenje (P2 §3.13). Web Share, kjer je; sicer odložišče — in to mora
  // uporabnik izvedeti, sicer izgleda, kot da gumb ni naredil ničesar.
  'station.share': 'Share',
  'station.share.aria': 'Share {station}',
  'station.share.copied': 'Address copied',

  'station.form.name': 'Name',
  'station.form.url': 'Stream address',
  'station.form.tags': 'Genres',
  'station.form.tags.hint': 'Separate with commas.',
  'station.form.country': 'Country code',
  'station.form.country.hint': 'Two letters, such as SI or US.',
  // Brez besede „napaka", brez kod, brez klicajev, brez krivde (P4 §5).
  'station.form.error.name': 'Give the station a name.',
  'station.form.error.url': 'The address needs to start with http:// or https://.',
  'station.form.error.duplicate': 'That address is already on your list.',

  // Samodejno dopolnjevanje (P2 §1.12). Izrecno dejanje, ne tiha magija —
  // gumb je velelnik, statusi so kratki in brez besede „napaka" (P4 §4, §5).
  'station.form.enrich': 'Fetch details',
  'station.form.enrich.busy': 'Looking…',
  'station.form.enrich.done': 'Filled in what the catalogue had.',
  'station.form.enrich.none': 'Nothing matched that address. Fill the rest in yourself.',
  'station.form.enrich.need': 'Enter a name and address first.',

  'dialog.close': 'Close',
  'dialog.cancel': 'Cancel',
  'dialog.save': 'Save',

  // Nastavitve — razdelek »vaši podatki«. Zaslon dobi temo, jezik in EQ v fazi 5.
  'settings.data.heading': 'Your data',
  'settings.export.stations.title': 'Export stations',
  'settings.export.stations.desc': 'Just the station list — for sharing with someone else.',
  'settings.export.full.title': 'Export everything',
  'settings.export.full.desc':
    'Stations and settings — for moving to a new device, or as a safety net.',
  'settings.export.action': 'Export',
  // Prenos je na namizju viden (vrstica prenosov), na mobilnem PWA pogosto ne —
  // zato toast potrdi, da se je kaj zgodilo. Ujema se z `onExport` v `main.ts`.
  'settings.export.toast.title': 'Exported',
  'settings.export.toast.stations': 'Your station list has been saved.',
  'settings.export.toast.full': 'A full backup has been saved — stations, history and settings.',
  'settings.import.title': 'Import',
  'settings.import.desc': 'You see what changes before anything is saved.',
  'settings.import.action': 'Choose file',
  'settings.seed.title': 'Remove the preloaded stations',
  'settings.seed.desc': 'The ones that came with the app. Yours stay.',
  'settings.seed.action': 'Remove',
  'settings.seed.confirm.title': 'Remove the preloaded stations?',
  'settings.seed.confirm.body': 'They will not come back. Stations you added yourself stay.',
  'settings.seed.none': 'Already removed',

  // Nasprotje odstranitve. Obstaja, ker se seed naloži SAMO ob prvem zagonu
  // (T2 §9) — kdor je aplikacijo že odprl, novih prednaloženih postaj sicer
  // nikoli ne dobi. Dejanje je izrecno: tiho prilivanje bi vračalo postaje,
  // ki jih je uporabnik namerno izbrisal.
  'settings.seed.restore.title': 'Add the preloaded stations',
  'settings.seed.restore.desc': 'Adds the ones missing from your list. Yours stay as they are.',
  'settings.seed.restore.action': 'Add',
  'settings.seed.restore.none': 'All present',
  'settings.seed.restore.count.one': '{n} station will be added',
  'settings.seed.restore.count.two': '{n} stations will be added',
  'settings.seed.restore.count.few': '{n} stations will be added',
  'settings.seed.restore.count.other': '{n} stations will be added',
  // Izid dejanja pristane na DRUGEM zaslonu (Postaje), zato toast potrdi tukaj.
  'settings.seed.restore.toast.title': 'Added to your list',
  'settings.seed.restore.toast.one': '{n} station added',
  'settings.seed.restore.toast.two': '{n} stations added',
  'settings.seed.restore.toast.few': '{n} stations added',
  'settings.seed.restore.toast.other': '{n} stations added',

  // Počisti vse podatke (P2 §6.16) — najbolj rušilno dejanje v aplikaciji.
  'settings.reset.title': 'Clear all data',
  'settings.reset.desc':
    'Removes all stations, history and settings. Export first if you want to keep a copy.',
  'settings.reset.action': 'Clear all',
  'settings.reset.confirm.title': 'Clear all data?',
  'settings.reset.confirm.body':
    'All your stations, all history and your settings will be deleted. This cannot be undone. If you exported a copy first, you can import it later.',
  'settings.reset.done.title': 'Data cleared',
  'settings.reset.done.body':
    'The app is empty again. You can add the preloaded stations back from here.',

  // Videz — tema in jezik dobita pravi preklop v fazi 5 (D1). Vsak je izbira
  // enega iz dveh (`.ao-segctrl` z `aria-pressed`).
  'settings.appearance.heading': 'Appearance',
  'settings.theme.title': 'Theme',
  'settings.theme.desc': 'Dark is the default. Light works too.',
  'settings.theme.dark': 'Dark',
  'settings.theme.light': 'Light',
  'settings.lang.title': 'Language',
  'settings.lang.desc': 'English or Slovenian.',
  // Jezik se poimenuje v svojem jeziku (endonim), ne glede na vmesnik.
  'settings.lang.en': 'English',
  'settings.lang.sl': 'Slovenščina',

  /* ── Zvok: ekvalizer in vizualizator (faza 6, P2 §6.3–6.5) ────── */

  'settings.sound.heading': 'Sound',

  'settings.eq.title': 'Equaliser',
  // Opozorilo iz T1 §4 / P2 §6.4. Pove, kaj se zgodi in kaj narediti, če moti —
  // brez besede „napaka", brez klicaja, brez krivde (P4 §5).
  'settings.eq.desc':
    'The equaliser needs the stream to come through our server. On slow mobile networks that can stutter — turn it off if it does.',
  // Odpoved je glasna, ne tiha (P2 §6.5): pove, zakaj in da to ni zlom.
  'settings.eq.unsupported': 'Safari on iPhone and iPad cannot run this on a live stream.',
  'settings.eq.unsupported.title': 'Not available here',
  'settings.eq.unsupported.body':
    'Safari on iPhone and iPad cannot process a live stream. Playback keeps working.',

  'settings.eq.preset': 'Preset',
  'settings.eq.preset.flat': 'Flat',
  'settings.eq.preset.rock': 'Rock',
  'settings.eq.preset.pop': 'Pop',
  'settings.eq.preset.jazz': 'Jazz',
  'settings.eq.preset.classical': 'Classical',
  'settings.eq.preset.bass': 'Bass boost',
  'settings.eq.preset.treble': 'Treble boost',
  'settings.eq.preset.vocal': 'Voice',
  // Ni izbira, ampak izid: nastane, ko uporabnik premakne drsnik.
  'settings.eq.preset.custom': 'Custom',
  'settings.eq.reset': 'Reset to flat',

  // Enota je obvezna: sama številka bralcu zaslona ne pove ničesar (D2 §6).
  // Slovenščina rabi vse štiri oblike; angleščina uporabi le one in other (P4 §9).
  'settings.eq.db.one': '{value} decibel',
  'settings.eq.db.two': '{value} decibels',
  'settings.eq.db.few': '{value} decibels',
  'settings.eq.db.other': '{value} decibels',
  'settings.eq.hz': '{n}{nbsp}Hz',
  'settings.eq.khz': '{n}{nbsp}kHz',

  'settings.visualizer.title': 'Spectrum',
  // Okras in nič drugega (CLAUDE.md, pravilo 1) — in ima isto ceno kot EQ.
  'settings.visualizer.desc': 'Decoration only. Needs the same route through our server.',

  /* ── Tipkovnica (faza 7, P2 §8.8) ──────────────────────────────── */

  // Bližnjica, ki je nikjer ne piše, ne obstaja. Seznam je hkrati edino mesto,
  // kjer je zapisano, da med tipkanjem ne delujejo — to je pomembnejše od
  // seznama samega, ker bi presledek sicer sredi iskanja ustavil zvok.
  'settings.keys.heading': 'Keyboard',
  'settings.keys.desc': 'Shortcuts work everywhere except while typing in a field.',
  'settings.keys.space': 'Space',
  'settings.keys.playPause': 'Play or stop',
  'settings.keys.previous': 'Previous station',
  'settings.keys.next': 'Next station',
  'settings.keys.volumeUp': 'Volume up',
  'settings.keys.volumeDown': 'Volume down',
  'settings.keys.mute': 'Mute or unmute',

  /* ── Zavihki Nastavitev (B-4) ───────────────────────────────────── */

  // Napisi zavihkov so `settings.appearance.heading`, `settings.sound.heading`
  // in `settings.data.heading` — isti ključi kot prej naslovi razdelkov. Nov je
  // samo četrti: pokriva tipkovnico, »o aplikaciji« IN zasebnost, zato se ne
  // sme imenovati po nobenem od njih.
  'settings.tabs.label': 'Settings sections',
  'settings.info.heading': 'Info',

  'settings.about.heading': 'About',
  // Žig gradnje stoji ob različici, vezan nanjo z nedeljivima presledkoma:
  // »0.9.0 · 3c9069d« se ne sme prelomiti na dve vrstici, »Version« pa se sme.
  'settings.about.version': 'Version {version}{nbsp}·{nbsp}{build}',
  /**
   * ⚠️ **Razdelek govori o poslušalcu, ne o nas.** Prej je pisalo »zgrajen na
   * oblikovnem sistemu Nesylab« — dejstvo o tem, kako smo gradili, ki
   * uporabniku ne pove ničesar. Napis v glavi je tako ali tako vedno
   * `nesylab`, torej je bila pripadnost povedana dvakrat in v uporabnikovem
   * jeziku nobenkrat.
   *
   * Besedilo ni novo: prva poved je [P1 §1], druga načelo »poštenost pred
   * lepoto« [P1 §5.1]. Vsaka trditev je **merljiva** in ima svojo funkcijo v
   * P2 — zato to ni slogan, ampak zaveza.
   *
   * ⛔ **Ne ponavljaj zasebnosti**, ki stoji tik pod tem razdelkom. »Brez
   * reklam« sme stati na obeh mestih (tu obljuba, tam podatkovno dejstvo),
   * seznam »ni računa, ni analitike, ni piškotkov« pa pripada samo tja.
   */
  'settings.about.desc': 'Radio that opens and plays. No ads, no account, no waiting.',
  'settings.about.promise':
    'Your stations stay yours — on this device, in the order you put them. When the stream drops, you see it: the retry is visible, not silent.',
  // Kredit, ne pravna opomba: brez teh dveh projektov imenika ne bi bilo.
  'settings.about.licences':
    'The station directory is kept up by two community projects, radio-browser and WebRadioDB.',

  /* ── Politika zasebnosti (faza 7, P2 §6.15) ─────────────────────── */

  // Vsaka trditev tu je preverjena v kodi, ne prepisana od drugod. Kdor jo
  // spremeni, mora najprej spremeniti kodo — politika, ki opisuje včerajšnjo
  // aplikacijo, je slabša od nobene.
  'settings.privacy.heading': 'Privacy',
  'settings.privacy.intro':
    'Nesywave has no accounts, no advertising and no analytics. Your stations, settings, history and listening time stay on this device.',
  'settings.privacy.updated': 'Last updated {date}',

  'settings.privacy.device.title': 'What stays on this device',
  'settings.privacy.device.body':
    'Stations, settings, listening history and statistics live in this browser, in localStorage and IndexedDB. There is no copy on our server, because there is no account to attach one to. Export writes a file you keep yourself; import reads only a file you pick. Clearing this site’s browser data removes all of it.',

  'settings.privacy.server.title': 'What goes through our server',
  'settings.privacy.server.intro':
    'Audio goes straight from your device to the station by default. Our server at wave.nesylab.com steps in only in these cases.',
  'settings.privacy.server.stream':
    'Stream relay — when a station has no HTTPS address, or when you switch on the equalizer or the visualizer.',
  'settings.privacy.server.probe':
    'HTTPS probe — when a station address starts with http://. Before connecting, the server asks Cloudflare DNS whether the address points into a private network, and refuses it if it does.',
  'settings.privacy.server.catalog':
    'Station directory — while you search. Queries go to radio-browser, with WebRadioDB as a fallback, and answers are kept for 24 hours.',
  'settings.privacy.server.art':
    'Track titles and cover art — while a station plays. First the station’s own metadata, then MusicBrainz, Cover Art Archive and Deezer. Apple Music is asked by the browser itself.',
  'settings.privacy.server.limit':
    'Every request carries an IP address. The server counts it against a limit of 60 requests per minute and then forgets it. Cloudflare hosts the server and keeps short technical logs; what you listen to is recorded nowhere.',

  'settings.privacy.station.title': 'What the station sees',
  'settings.privacy.station.body':
    'When audio goes direct, your device talks to the station itself, so its operator sees the request the way any website would: an IP address, a time and a browser identification. That is how internet radio works, not a choice Nesywave makes. Sending everything through our server would hide it from the station and show it to us instead.',

  'settings.privacy.external.title': 'Leaving the app',
  'settings.privacy.external.body':
    '“Find this song” opens Apple Music, Spotify or YouTube in a new tab, where their terms apply and ours no longer do. When you preview a station from the directory, the browser reports one click back to radio-browser — that is how the directory learns which stations are used. The click carries the station identifier, and radio-browser sees the request the way any website would.',

  'settings.privacy.none.title': 'What Nesywave never does',
  'settings.privacy.none.body':
    'No account, no sign-in, no advertising, no analytics, no tracking. Nesywave sets no cookies at all. Nothing is sold or passed on, because nothing is collected to begin with.',

  'backup.import.title': 'Import stations',
  // Slovenščina rabi vse štiri oblike; angleščina uporabi le one in other (P4 §9).
  'backup.preview.total.one': '{n} station in the file',
  'backup.preview.total.two': '{n} stations in the file',
  'backup.preview.total.few': '{n} stations in the file',
  'backup.preview.total.other': '{n} stations in the file',
  'backup.preview.added.one': '{n} is new',
  'backup.preview.added.two': '{n} are new',
  'backup.preview.added.few': '{n} are new',
  'backup.preview.added.other': '{n} are new',
  'backup.preview.duplicate.one': '{n} is already on your list',
  'backup.preview.duplicate.two': '{n} are already on your list',
  'backup.preview.duplicate.few': '{n} are already on your list',
  'backup.preview.duplicate.other': '{n} are already on your list',
  'backup.preview.settings': 'Settings in the file will replace yours.',
  'backup.mode.merge': 'Merge',
  'backup.mode.merge.desc': 'Keep what you have, add what is new.',
  'backup.mode.replace': 'Replace',
  'backup.mode.replace.desc': 'Your list is replaced by the one in the file.',
  'backup.import.action': 'Import',
  'backup.error.unreadable': 'That file could not be read.',
  'backup.error.not-a-backup': 'That is not a Nesywave export.',
  'backup.error.too-new': 'That file comes from a newer version of Nesywave.',
  'backup.error.migration-failed': 'That file could not be converted to the current format.',

  // Žanri iz seeda, prevedeni za izpis. Shranjeni ostanejo v angleščini, kot
  // jih pošilja radio-browser (T2 §9) — dvojezičen slovar bi pomenil, da
  // `rock` in `rok` nista ista stvar. Neznan žanr se izpiše surov.
  'genre.pop': 'Pop',
  'genre.rock': 'Rock',
  'genre.jazz': 'Jazz',
  'genre.classical': 'Classical',
  'genre.electronic': 'Electronic',
  'genre.ambient': 'Ambient',
  'genre.dance': 'Dance',
  'genre.folk': 'Folk',
  'genre.indie': 'Indie',
  'genre.talk': 'Talk',
  'genre.news': 'News',
  'genre.culture': 'Culture',
  'genre.religious': 'Religious',

  /* ── Iskanje po spletni bazi (faza 4, P2 §2) ───────────────────── */

  'search.field.label': 'Search the online directory',
  'search.field.placeholder': 'Station name',
  'search.filter.country': 'Country',
  'search.filter.country.any': 'Any country',
  'search.filter.genre': 'Genre',
  'search.filter.genre.any': 'Any genre',
  // Combobox (DS `.cmb`, od v4.20.10). Gumba nosita samo ikono, zato je ime
  // v `aria-label` — velelnik, kot vsak drug gumb (P4 §4).
  'search.filter.clear': 'Clear filter',
  'search.filter.open': 'Open list',
  'search.filter.noMatch': 'Nothing matches',
  'search.filter.count': '{n}',

  // Slovenščina rabi vse štiri oblike; angleščina uporabi le one in other (P4 §9).
  'search.results.count.one': '{n} station found',
  'search.results.count.two': '{n} stations found',
  'search.results.count.few': '{n} stations found',
  'search.results.count.other': '{n} stations found',

  // Prazno stanje ima naslov, opis in dejanje — nikoli le „ni podatkov" (P4 §6).
  // Prvi obisk ni prazen rezultat: nič se še ni iskalo in pot naprej je druga.
  'search.start.title': 'Find a station',
  'search.start.body': 'Type a name, or pick a country or genre to see what people listen to most.',
  'search.empty.title': 'Nothing found',
  'search.empty.body': 'Try a shorter name, or drop one of the filters.',

  // Brez besede „napaka", brez kod, brez klicajev, brez krivde (P4 §5).
  'search.failed.title': 'The directory did not answer',
  'search.failed.body': 'The station list comes from a service that is sometimes busy.',
  'search.failed.action': 'Try again',
  'search.offline.title': 'No connection',
  'search.offline.body': 'Search needs a connection. Your own stations keep playing.',

  'search.loading': 'Searching…',
  'search.more': 'Show more',
  'search.preview': 'Preview {station}',
  'search.add': 'Add',
  'search.add.aria': 'Add {station} to my stations',
  'search.added': 'On your list',
  'search.added.aria': '{station} is already on your list',
  // Kateri vir je odgovoril, je podatek in ne opozorilo (CLAUDE.md, signal ≠ status).
  'search.source.fallback': 'From the backup directory',

  'station.insecure.badge': 'HTTP',
  'station.insecure.title': 'Station streams over an insecure connection',
  'station.insecure.hint': 'Playback goes through our server.',

  /* ── Zgodovina (P2 §4) ─────────────────────────────────────────── */

  'history.search.label': 'Search history',
  'history.search.placeholder': 'Search',
  'history.clearAll': 'Clear all',
  'history.clearAll.confirm.title': 'Clear all history?',
  'history.clearAll.confirm.body':
    'Played songs and listening time will be gone. This cannot be undone.',
  // aria-oznaka gumba za brisanje skupine; {station} je ime postaje.
  'history.clearStation': 'Clear history for {station}',
  'history.clearStation.action': 'Clear',
  'history.clearStation.confirm.title': "Clear this station's history?",
  'history.clearStation.confirm.body':
    'Its played songs and listening time will be gone. Other stations stay.',
  // Tap kopira naslov (§4.4); {track} je izvajalec — naslov.
  'history.copy': 'Copy {track}',
  'history.copied': 'Copied',
  /* Žig vnosa (§4.13). Današnji nosi samo uro, zato ključa nima. Ločilo je
     tu in ne v kodi: angleščina piše vejico kot v datumu, slovenščina je za
     piko okrajšave ne postavi (P4 §7). */
  'history.at.yesterday': 'Yesterday, {time}',
  'history.at.dated': '{date}, {time}',
  // Postaja je bila izbrisana, zgodovina pa jo pomni.
  'history.unknownStation': 'Removed station',
  'history.empty.title': 'No history yet',
  'history.empty.body': 'Songs you hear will show up here, grouped by station.',
  'history.empty.filtered.title': 'Nothing matches',
  'history.empty.filtered.body': 'Try another search.',

  /* ── Časovnik spanja (P2 §5) ───────────────────────────────────── */

  'timer.presets.heading': 'Presets',
  'timer.preset': '{n}{nbsp}min',
  'timer.custom.heading': 'Custom time',
  'timer.hours': 'Hours',
  'timer.minutes': 'Minutes',
  'timer.start': 'Start',
  'timer.cancel': 'Cancel timer',
  'timer.minus': '−5{nbsp}min',
  'timer.plus': '+5{nbsp}min',
  'timer.minus.aria': 'Five minutes less',
  'timer.plus.aria': 'Five minutes more',
  'timer.remaining': '{time} left',
  'timer.active': 'Music stops when the timer runs out.',
  'timer.fading': 'Fading out…',
} as const;

export type TranslationKey = keyof typeof en;
